// src/components/Footer.js
import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Todos los derechos reservados.</p>
    </footer>
  );
}

export default Footer;
